import SniperAssets from './SniperAssets.vue'

export default SniperAssets
